import { TokenService } from '@package/service'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import router from './common/router/index.js'
import 'nprogress/nprogress.css'
import { pinias } from './common/pinia/index'

const { login } = pinias
const userLogin = login()
// import pinia from 'pinia'
// import loginStore from './modules/login/pinia/pinia.js'
const whiteList = ['']
NProgress.configure({ showSpinner: false })

router.beforeEach((to, from, next) => {
  NProgress.start()
  // hasToken(to, from, next)
  if (TokenService.getToken('TokenNew')) {
    hasToken(to, from, next)
  } else {
    whithoutToken(to, from, next)
  }
})

router.afterEach(() => {
  NProgress.done()
})

async function hasToken(to, from, next) {
  // to.meta.title && settingsStore.setTitle(to.meta.title);
  if (to.path === '/login' || to.path === '/noredirect') {
    next({ path: '/home' })
    NProgress.done()
    return
  }
  if (userLogin.menus.length || userLogin.user.id) {
    const menus = userLogin.menus
    if ((menus.length && JSON.stringify(menus).indexOf(to.path) !== -1)) {
      return next()
    }
    next({ path: '/' })
    return
  }
  try {
    if ((userLogin.menus.length && JSON.stringify(userLogin.menus).indexOf(to.path) !== -1)) {
      next({ path: '/404' })
      return
    }
    await userLogin.getInfo()
    await userLogin.getUserMenus()
    next({ ...to, replace: true })
  } catch (err) {
    console.error('ERROR', err)
    await userLogin.LogOut()
    Message.error(err)
    next({ path: '/' })
  }
}

async function whithoutToken(to, from, next) {
  if (to.path === '/login' || to.path === '/noredirect') return next()
  if (to.path === '/login/password_find' || to.path === '/login/nick_find'|| to.path === '/register' || to.path === '/signTools/iWebPDF.html') return next()
  next(`/login?redirect=${to.fullPath}`)
  NProgress.done()
}
